import React from 'react';

/**
 * AlternativeUpload - Shows upload button for existing documents
 */
function AlternativeUpload({ task, fileInputRef, uploading, files }) {
  const hasFiles = files && files.length > 0;
  
  return (
    <div className="mb-4" data-testid="alternative-upload">
      <p className="text-xs font-semibold text-slate-400 uppercase tracking-wide mb-2">
        {hasFiles ? 'Dokumentasjon' : 'Har du allerede dette?'}
      </p>
      <button
        onClick={() => fileInputRef.current?.click()}
        disabled={uploading}
        className={`w-full p-3 rounded-xl border text-left transition-all ${
          hasFiles 
            ? 'border-emerald-500/30 bg-emerald-500/10 hover:border-emerald-500/50' 
            : 'border-slate-700 bg-slate-800/50 hover:border-cyan-500/50 hover:bg-slate-800'
        }`}
        data-testid="upload-document-btn"
      >
        <div className="flex items-center gap-3">
          <div className={`w-8 h-8 rounded-full flex items-center justify-center ${
            hasFiles ? 'bg-emerald-500/20' : 'bg-slate-700/50'
          }`}>
            {uploading ? (
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-cyan-500"></div>
            ) : hasFiles ? (
              <svg className="w-4 h-4 text-emerald-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            ) : (
              <svg className="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
              </svg>
            )}
          </div>
          <div className="flex-1">
            <p className={`text-sm font-medium ${hasFiles ? 'text-emerald-300' : 'text-slate-200'}`}>
              {hasFiles ? `${files.length} dokument${files.length > 1 ? 'er' : ''} lastet opp` : 'Last opp eksisterende dokument'}
            </p>
            <p className={`text-xs ${hasFiles ? 'text-emerald-400/70' : 'text-slate-500'}`}>
              {hasFiles ? 'Klikk for å legge til flere' : 'Slipper å gjøre det på nytt hvis du allerede har'}
            </p>
          </div>
          <svg className={`w-4 h-4 ${hasFiles ? 'text-emerald-400' : 'text-slate-500'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
        </div>
      </button>
    </div>
  );
}

export default AlternativeUpload;
